module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-fill-b9d9d307.svg";